import React, { FC } from 'react';

interface StatusCellProps {
  status: string;
}

const colorForStatus = {
  error: 'red',
  fail: 'red',
  missing: 'red',
  not_started: 'red',
  submitted: 'red',
  unknown: 'red',

  not_required: 'gray',

  in_progress: 'cadetblue',

  inactive: 'orange',
  pending_approval: 'orange',

  active: 'green',
  approved: 'green',
  complete: 'green',
  pass: 'green',
  reviewed: 'green',
  success: 'green',
};

const formatText = (str) => str?.split('_')?.join(' ');

const StatusCell: FC<StatusCellProps> = (props) => {
  let { status } = props;

  return (
    <div
      style={{
        fontWeight: 700,
        textTransform: 'uppercase',
        color: colorForStatus[status],
      }}
    >
      {formatText(status)}
    </div>
  );
};

export default StatusCell;
